import { ThemeProvider } from "@mui/material/styles";
import { AppRouterProvider } from "./pages/Router";
import { ModalProvider } from "./providers/ModalProvider";
import { ToastProvider } from "./providers/ToastProvider";
import { theme } from "./mui.config";
import { CssBaseline } from "@mui/material";
import './App.scss';
import CookieConsent from "react-cookie-consent";
import { useEffect, useCallback } from "react";

const loadClarity = (projectId: string): void => {
  if (window.clarity) return;

  const script = document.createElement("script");
  script.src = `https://www.clarity.ms/tag/${projectId}`;
  script.async = true;
  document.head.appendChild(script);
};

const App = () => {
  const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID || "";

  const initClarityIfConsented = useCallback(() => {
    if (localStorage.getItem("CookieConsent") === "true") {
      loadClarity(clarityProjectId);
    }
  }, [clarityProjectId]);

  useEffect(() => {
    initClarityIfConsented();
  }, [initClarityIfConsented]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ToastProvider>
        <ModalProvider>
          <AppRouterProvider />
        </ModalProvider>
      </ToastProvider>
      {/* Cookie Consent Banner */}
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        buttonId="accept"
        declineButtonText="Decline"
        declineButtonId="decline"
        enableDeclineButton
        cookieName="myAppCookieConsent"
        style={{
          background: theme.palette.primary.contrastText,
          color: theme.palette.primary.main,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "16px 24px",
          boxShadow: theme.shadows[4],
          zIndex: 1300,
        }}
        buttonStyle={{
          background: theme.palette.primary.main,
          color: theme.palette.primary.contrastText,
          fontSize: theme.typography.button.fontSize,
          borderRadius: 4,
          padding: "8px 16px",
          border: "none",
          cursor: "pointer",
        }}
        declineButtonStyle={{
          background: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          fontSize: theme.typography.button.fontSize,
          borderRadius: 4,
          padding: "8px 16px",
          border: "none",
          cursor: "pointer",
          marginLeft: 12,
        }}
        expires={365}
      >
        We use cookies to improve your experience. Click "Accept" to consent, or "Decline" to reject non-essential cookies.
      </CookieConsent>
    </ThemeProvider>
  );
}

export default App;
